












import Vue from 'vue'
import { mapState } from 'vuex'

export default Vue.extend({
  props: ['props'],
  data: () => ({
    visible: false,
  }),
  computed: mapState('content', ['alert']),
  watch: {
    alert(v) {
      this.visible = !!v
    },

    visible(v) {
      if (!v && this.alert) {
        this.$store.commit('content/hideAlert')
      }
    },
  },
  created() {
    this.visible = !!this.alert
  },
})
